import React, { useState, useEffect } from "react";
import styles from "./SelectPaymentMethod.module.scss";
import CreditCard from "../../assets/images/vector.png";
import OpayLogo from "../../assets/images/Opay.svg";
import CryptoLogo from "../../assets/images/pay-crypto.svg";
import PalmpayLogo from "../../assets/images/palmpay-logo.svg";
import TransferIcon from "../../assets/images/f7_paperplane-fill.png";
import SafeIcon from "../../assets/images/mdi_secure.svg";
import DebitCard from "../../components/DebitCard/DebitCard";
import USSD from "../../assets/images/ussd.svg";
import qr from "../../assets/images/qr-code.svg";
import Transfer from "../../components/Transfer/Transfer";
import PoweredBy from "../../components/PoweredBy/PoweredBy";
import SubHeader from "../subHeader/subHeader";
import { ArrowBack } from "@material-ui/icons";
import MerchantDetail from "../../views/CheckoutHome/MerchantDetail";
import { useSelector, useDispatch } from "react-redux";
import queryString from "query-string";
import { commarize } from "../../utils/helpers";
import DirectDebit from "../DirectDebit/DirectDebit";
import { Post } from "../../api/client";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { saveOrderFeeAction } from "../../redux/actions/orderfee/orderFeeAction";
import {
  openLoader,
  closeLoader,
} from "../../redux/actions/loader/loaderActions";
import Ussd from "../Ussd/Ussd";
import QrCode from "../QrCode/QrCode";
import PayWithOpay from "../PayWithOpay/pay-with-opay";
import { PayWithMomo } from "../PayWithMomo/pay-with-momo";
import PayWithPalmpay from "../PayWithPalmpay/pay-with-palmpay";
import merchantlogo from "../../assets/images/paymentgateway.png";
import customerService from "../../assets/icons/customer-service.svg";
import pattern from "../../assets/images/footer-pattern.svg";
import transactpay from "../../assets/images/iconlogo.png";
import PayWithCrypto from "../PayWithCrypto/pay-with-crypto";
import { PayWithMomoMali } from "../PayWithMomoMali/pay-with-momo-mali";

type BackButtonProps = {
  onClick: () => void;
};
type PaymentMethodHeaderProps = {
  onClick: () => void;
};

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      border: "none",
      background: "transparent",
      justifyContent: "center",
      color: "#8E173E",
      fontWeight: "400",
      cursor: "pointer",
      padding: "10px 0",
    }}
  >
    <ArrowBack style={{ marginRight: "5px", fontSize: "14px" }} />
    Back
  </button>
);

export const PaymentMethodHeader = ({ onClick }: PaymentMethodHeaderProps) => {
  return (
    <div
      className={styles.headerWrapper}
      style={{
        display: "flex",
        width: "100%",
        alignItems: "start",
        justifyContent: "space-between",
        padding: "10px 10px",
      }}
    >
      <BackButton onClick={onClick} />

      {/* Always render SubHeader until "Initiate Payment" is clicked */}
      {/* {showSelectionPage || selectedValue !== "bank transfer" ? ( */}
      <div className={styles.transactionDetails}>
        <SubHeader />
      </div>
      {/* ) : null} */}
    </div>
  );
};

const SelectPaymentMethod = () => {
  const [showSelectionPage, setShowSelectionPage] = useState(true); // Toggle between selection and details page
  const [showReminder, setShowReminder] = useState(false); // Show gray reminder box when a method is selected
  const body = queryString.parse(window.location.search);
  const dispatch = useDispatch();
  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);

  // Get current mode if live or test
  const liveStatus = useSelector(
    (state: any) => state.liveStatusReducer.isLive,
  );
  const sessionliveStatus = sessionStorage.getItem("isLive");

  const getCookie = (name: string): string | undefined => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";")?.shift();
    return undefined;
  };
  // Get the 'isLive' value from cookies
  const cookieLiveStatus = getCookie("isLive");
  const isTestMode =
    liveStatus === "false" ||
    liveStatus === false ||
    (liveStatus !== null &&
      (cookieLiveStatus === "false" || sessionliveStatus === "false"));

  // console.log({ orderDetails });
  const merchantLogo = orderDetails?.data?.subsidiary?.customization?.[0];
  const orderfee = useSelector((state) => state.orderFeeReducer);
  const fee: number = orderfee?.data?.customerFee ?? 0;
  const merchantEmail =
    orderDetails?.data?.subsidiary?.email ??
    orderDetails?.data?.customer?.email;
  const currency = orderDetails?.data?.order?.currency;
  const newamount = orderDetails?.data?.newAmount;
  const isDiscounted = orderDetails?.data?.isDiscounted;
  const reference = body?.orderId
    ? body.orderId
    : orderDetails?.data?.order?.reference;
  const address = (body?.customer as { address?: string })?.address ?? " ";

  // const address = body?.address ? body.orderId : '';
  const amount = orderDetails?.data?.order?.amount;
  const otherpaymentmethods = orderDetails?.data?.otherPaymentOptions || [];
  const savedCards = orderDetails?.data?.savedCards || [];
  const paymentmethods = [
    {
      name: "DebitCard",
      value: "card",
      backendCode: "C",
      icon: (
        <img src={CreditCard} alt="Credit Card Icon" className={styles.icon} />
      ),
      displayText: "Pay With Card",
    },
    {
      name: "BankTransfer",
      value: "bank transfer",
      backendCode: "BANK-TRANSFER",
      icon: (
        <img src={TransferIcon} alt="Transfer Icon" className={styles.icon} />
      ),
      displayText: "Pay With Bank Transfer",
    },
    ...(isTestMode
      ? []
      : [
          {
            name: "Ussd",
            value: "ussd",
            backendCode: "ussd",
            icon: <img src={USSD} alt="USSD Icon" className={styles.icon} />,
            displayText: "USSD",
            paymentinstruction: "Select bank to begin payment",
          },
          {
            name: "QRCode",
            value: "qrcode",
            icon: <img src={qr} alt="QR Icon" className={styles.icon} />,
            displayText: "QR Code",
            paymentinstruction: "Scan QR code to complete your payment",
          },
          {
            name: "OPay",
            value: "opay",
            displayText: "Pay with OPay",
            paymentInstruction: "Click to payment",
            backendCode: "Opay",
            icon: (
              <img src={OpayLogo} alt="USSD Icon" className={styles.icon} />
            ),
          },
          {
            name: "Palmpay",
            value: "palmpay",
            displayText: "Pay with Palmpay",
            paymentInstruction: "Click to payment",
            backendCode: "palmpay",
            icon: (
              <img src={PalmpayLogo} alt="USSD Icon" className={styles.icon} />
            ),
          },
          {
            name: "MoMo",
            value: "momo",
            displayText: "Pay with Momo",
            paymentInstruction: "Click to payment",
            backendCode: "Momo",
            icon: <>M</>,
          },
          {
            name: "Pay With MOMO Mali",
            value: "MOMO-MALI",
            displayText: "Pay With Momo Mali",
            paymentInstruction: "Click to payment",
            backendCode: "MOMO-MALI",
            icon: (
              <img
                src={PalmpayLogo}
                alt="Palmpay Icon"
                className={styles.icon}
              />
            ),
          },
          {
            name: "Palmpay(MOMO)",
            value: "palmpay(MOMO)",
            displayText: "Pay with Palmpay (MOMO)",
            paymentInstruction: "Click to payment",
            backendCode: "Palmpay(MOMO)",
            icon: (
              <img
                src={PalmpayLogo}
                alt="Palmpay Icon"
                className={styles.icon}
              />
            ),
          },
          {
            name: "Crypto",
            value: "crypto",
            displayText: "Pay with Crypto",
            paymentInstruction: "Click to payment",
            backendCode: "Crypto",
            icon: (
              <img
                src={CryptoLogo}
                alt="USSD Icon"
                className={styles.cryptoIcon}
              />
            ),
          },
          {
            name: "Trust",
            value: "directdebit",
            backendCode: "DIRECT-DEBIT",
            icon: (
              <img src={SafeIcon} alt="Safe Pay Icon" className={styles.icon} />
            ),
            displayText: "Pay With Trust",
          },
        ]),
  ];

  // Temporary to always include direct debit
  const availablePaymentMethods = paymentmethods.filter((method) =>
    otherpaymentmethods.some(
      (backendMethod: { code: string }) =>
        backendMethod.code.toUpperCase() === method?.backendCode?.toUpperCase(),
    ),
  );

  // || method.value === "directdebit" // Always include Direct Debit

  const amountToDisplay = body?.orderId
    ? `${currency ?? "NGN"} ${commarize((amount ?? 0) + fee)}`
    : isDiscounted
    ? `${currency ?? "NGN"} ${commarize(Number(newamount) + fee)}`
    : `${currency ?? "NGN"} ${commarize(Number(body.amount) + fee)}`;

  const fetchOrderFee = async (paymentMethod: string) => {
    if (!amount) return;
    // dispatch(openLoader("default"));
    try {
      const selectedMethod = paymentmethods.find(
        (method) => method.value === paymentMethod,
      )?.backendCode;

      const payload = {
        amount,
        currency,
        paymentOption: selectedMethod,
      };

      const response: any = await Post("payment/order/fee", payload);
      dispatch(saveOrderFeeAction({ data: response.data.data }));
    } catch (error: any) {
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: { background: "red", color: "white" },
          toastContent: message,
        }),
      );
    } finally {
      dispatch(closeLoader());
    }
  };

  // Pick default method based on switch-case default
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  useEffect(() => {
    if (availablePaymentMethods.length > 0 && !selectedValue) {
      setSelectedValue(availablePaymentMethods[0].value);
    }
  }, [availablePaymentMethods.length]);

  useEffect(() => {
    if (selectedValue) {
      fetchOrderFee(selectedValue).finally();
    }
  }, [selectedValue, amount]);

  const handleSelectPaymentMethod = (methodValue: string) => {
    setSelectedValue(methodValue);
    setShowReminder(true);
  };

  const getPaymentMethodComponent = () => {
    switch (selectedValue) {
      case "bank transfer":
        return <Transfer reference={reference} isTestMode={isTestMode} />;
      case "ussd":
        return <Ussd reference={reference} />;
      case "qrcode":
        return <QrCode reference={reference} />;
      case "directdebit":
        return (
          <DirectDebit
            saveCards={savedCards}
            reference={reference}
            currency={currency}
            amount={amount}
            email={merchantEmail}
            address={address}
          />
        );
      case "opay":
        return <PayWithOpay reference={reference} />;
      case "crypto":
        return <PayWithCrypto reference={reference} />;
      case "palmpay":
        return <PayWithPalmpay reference={reference} />;
      case "momo":
        return <PayWithMomo reference={reference} />;
      case "MOMO-MALI":
        return <PayWithMomoMali reference={reference} />;
      case "card":
      default:
        // Check if card is available
        // const isCardAvailable = paymentmethods.some(
        const isCardAvailable = availablePaymentMethods.some(
          (method) => method.value === "card",
        );

        // If card is available, show card component
        if (isCardAvailable) {
          return (
            <DebitCard
              reference={reference}
              currency={currency}
              amount={amount}
              saveCards={savedCards}
              isTestMode={isTestMode}
            />
          );
        }

        // Otherwise, render the first available payment method
        const firstMethod = availablePaymentMethods[0]?.value;

        switch (firstMethod) {
          case "bank transfer":
            return <Transfer reference={reference} />;
          case "ussd":
            return <Ussd reference={reference} />;
          case "qrcode":
            return <QrCode reference={reference} />;
          case "directdebit":
            return (
              <DirectDebit
                saveCards={savedCards}
                reference={reference}
                currency={currency}
                amount={amount}
                email={merchantEmail}
                address={address}
              />
            );
          case "opay":
            return <PayWithOpay reference={reference} />;
          case "crypto":
            return <PayWithCrypto reference={reference} />;
          case "palmpay":
            return <PayWithPalmpay reference={reference} />;
          case "momo":
            return <PayWithMomo reference={reference} />;
          case "MOMO-MALI":
            return <PayWithMomoMali reference={reference} />;
          default:
            return <div>No payment method available</div>;
        }
    }
  };

  const handleBackClick = () => {
    sessionStorage.removeItem("checkout-interval-tracker");
    sessionStorage.removeItem("checkout-track-start");
    if (showSelectionPage) {
      if (window.history.length > 1) {
        // If there's a history to go back to, navigate back
        window.history.back();
      } else {
        // If no history exists, close the window
        if (window.confirm("No previous page found. Close the window?")) {
          window.close();
        }
      }
    } else {
      // Handle returning to the selection page
      setShowSelectionPage(true);
      setSelectedValue(null);
      setShowReminder(false);
    }
  };

  const handleInitiatePayment = () => {
    setShowSelectionPage(false);
    setShowReminder(false);
  };

  return (
    <>
      <section className={styles.pageContainer}>
        {/* primary content -active */}

        <>
          <main
            className={`${styles.pageContainerMain} ${
              showSelectionPage ? styles.hideOnMobile : styles.showOnMobile
            }`}
          >
            <div className={styles.header}>
              <img
                src={merchantLogo?.value ?? merchantlogo}
                alt={merchantLogo?.key ?? "logo"}
              />
              {isTestMode && (
                <div className={styles.modeIndicator}>Test Mode</div>
              )}
            </div>

            {/* Back button for small screens */}
            {/* <div className={styles.mobileBackWrapper}>
              <BackButton onClick={handleBackClick} />
            </div> */}

            <div className={styles.contentWrapper}>
              <div className={styles.methodDetails}>
                <PaymentMethodHeader onClick={handleBackClick} />
                {getPaymentMethodComponent()}
              </div>
            </div>

            <footer className={styles.footer}></footer>
          </main>

          {/* secondary - option menu - hidden on small screens */}
          <aside className={styles.pageContainerSide}>
            <div className={styles.header}></div>
            <div className={styles.contentWrapper}>
              <h5>Select Payment Method</h5>

              <ul style={{ padding: "0" }}>
                {availablePaymentMethods.map((method) => (
                  <li
                    key={method.name}
                    onClick={() => handleSelectPaymentMethod(method.value)}
                    className={`${styles.methodsSelection} ${
                      selectedValue === method.value ? styles.selected : ""
                    }`}
                    style={{
                      backgroundColor:
                        selectedValue === method.value ? "#FBE9EF" : "",
                      transition: "all 0.2s ease-in-out",
                      cursor: "pointer",
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleSelectPaymentMethod(method.value);
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div className={styles.icon}>{method.icon}</div>
                      <div className={styles.methodLabel}>
                        {method.displayText}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <footer className={styles.footer}>
              <a
                href={`mailto:${merchantEmail}`}
                className={styles.supportButton}
              >
                <img src={customerService} alt="icon-button" />
                <p>Talk to support</p>
              </a>

              <img src={pattern} alt="pattern" className={styles.pattern} />
            </footer>
          </aside>
        </>

        {/* the options on mobile */}
        {showSelectionPage && (
          <div className={styles.paymentmethodOptions}>
            <div
              className={styles.headerWrapper}
              style={{
                display: "flex",
                width: "100%",
                alignItems: "start",
                justifyContent: "space-between",
                padding: "10px 10px",
              }}
            >
              <BackButton onClick={handleBackClick} />

              {/* Always render SubHeader until "Initiate Payment" is clicked */}
              {showSelectionPage || selectedValue !== "bank transfer" ? (
                <div className={styles.transactionDetails}>
                  <SubHeader />
                </div>
              ) : null}
            </div>
            <div className={styles.paymentOptionWrapper}>
              <h6>Select Payment Method</h6>
            </div>

            <div className={styles.formSelection}>
              <div className={styles.paymentOptionListWrapper}>
                {availablePaymentMethods.map((method) => (
                  <div
                    key={method.name}
                    onClick={() => {
                      handleSelectPaymentMethod(method.value);
                      handleInitiatePayment();
                    }}
                    className={`${styles.radioSelection} ${
                      selectedValue === method.value ? styles.selected : ""
                    }`}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleSelectPaymentMethod(method.value);
                      }
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className={styles.icon}>{method.icon}</div>
                      <div className={styles.radioLabel}>
                        {method.displayText}
                      </div>
                    </div>
                  </div>
                ))}
                <img
                  src={pattern}
                  alt="pattern"
                  className={styles.mobilepattern}
                />
              </div>
            </div>

            {/* <button
              className={
                selectedValue ? styles.initiateButton : styles.disabledButton
              }
              disabled={!selectedValue}
              onClick={handleInitiatePayment}
            >
              Initiate Payment
            </button> */}

            {/* Powered by */}
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "auto",
              }}
            >
              <div className={styles.poweredByBox}>
                <p className={styles.poweredBy}>Powered by</p>
                <img
                  src={transactpay}
                  style={{ width: "auto", height: "20px", objectFit: "cover" }}
                  alt="Transactpay"
                />
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default SelectPaymentMethod;

// <MerchantDetail />
// <div className={styles.payment}>
//   {/* Header with Back Button and SubHeader */}

//   <div
//     style={{
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//     }}
//   >
// {/* <MerchantDetail /> */}
//     <div
//       className={styles.headerWrapper}
//       style={{
//         display: "flex",
//         width: "100%",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "10px 10px",
//       }}
//     >
//       <BackButton onClick={handleBackClick} />

//       {/* Always render SubHeader until "Initiate Payment" is clicked */}
//       {showSelectionPage || selectedValue !== "bank transfer" ? (
//         <div className={styles.transactionDetails}>
//           <SubHeader />
//         </div>
//       ) : null}
//     </div>
//   </div>
//   {showSelectionPage ? (
//     <div className={styles.paymentmethodOptions}>
//       {/* Gray Details Box shown when a method is selected but not initiated */}
//       {showReminder && selectedValue != "directdebit" && (
//         <div className={styles.greyBox}>
//           <div className={styles.greyBoxLeft}>
//             <h5>Total Amount</h5>
//             <h3>{amountToDisplay}</h3>
//             <p>Subtotal</p>
//             <p>Charges</p>
//           </div>
//           <div className={styles.greyBoxRight}>
// <p>{`${currency ?? "NGN"} ${
//   body?.orderId
//     ? commarize(amount)
//     : commarize(Number(newamount))
// }`}</p>
// <p>
//   {" "}
//   {currency ?? "NGN"} {fee}
// </p>
//           </div>
//         </div>
//       )}

//       <div className={styles.paymentOptionWrapper}>
//         <p>Select Payment Method</p>
//       </div>

//       <div className={styles.formSelection}>
//         <div className={styles.paymentOptionListWrapper}>
// {availablePaymentMethods.map((method) => (
//   <label
//     key={method.name}
//     className={`${styles.radioSelection} ${
//       selectedValue === method.value ? styles.selected : ""
//     }`}
//     style={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       padding: "10px",
//       cursor: "pointer",
//       border: "1px solid #e0e0e0", // Default border
//       borderRadius: "8px",
//       transition: "background-color 0.3s, border-color 0.3s",
//     }}
//   >
//     <div style={{ display: "flex", alignItems: "center" }}>
//       <div className={styles.icon}>{method.icon}</div>
//       <div className={styles.radioLabel}>
//         {method.displayText}
//       </div>
//     </div>
//     <input
//       type="radio"
//       name="paymentMethod"
//       value={method.value}
//       checked={selectedValue === method.value}
//       onChange={() => handleSelectPaymentMethod(method.value)}
//       className={styles.customRadio} // Custom styling from CSS
//     />
//   </label>
// ))}
//         </div>
//       </div>

// <button
//   className={
//     selectedValue ? styles.initiateButton : styles.disabledButton
//   }
//   disabled={!selectedValue}
//   onClick={handleInitiatePayment}
// >
//   Initiate Payment
// </button>
//     </div>
//   ) : (
//     <>
//       <div className={styles.selectedPaymentOption}>
// <div className={styles.methodDetails}>
//   {getPaymentMethodComponent()}
// </div>
//         <PoweredBy />
//       </div>
//     </>
//   )}
// </div>
